import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import Layout from './components/ui/Layout'
import Login from './pages/Login'
import InvoiceList from './pages/InvoiceList'
import InvoiceForm from './components/invoice/InvoiceForm'
import InvoicePrintPage from './components/invoice/InvoicePrintPage'
import Customers from './pages/Customers'
import Products from './pages/Products'
import Users from './pages/Users'
import Dashboard from './pages/Dashboard'
import Reports from './pages/Reports'
import EditRequests from './pages/EditRequests'

function PrivateRoute({ children, roles }: { children: React.ReactNode, roles?: string[] }) {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  if (roles && !roles.includes(user.role)) return <Navigate to="/invoices" replace />
  return <>{children}</>
}

function AppRoutes() {
  const { user } = useAuth()
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/invoices" /> : <Login />} />

      <Route path="/invoices" element={<PrivateRoute><Layout><InvoiceList /></Layout></PrivateRoute>} />
      <Route path="/invoices/new" element={<PrivateRoute><Layout><InvoiceForm /></Layout></PrivateRoute>} />
      <Route path="/invoices/:id/edit" element={<PrivateRoute><Layout><InvoiceForm /></Layout></PrivateRoute>} />
      <Route path="/invoices/:id/print" element={<PrivateRoute><InvoicePrintPage /></PrivateRoute>} />

      <Route path="/customers" element={<PrivateRoute><Layout><Customers /></Layout></PrivateRoute>} />

      <Route path="/products" element={<PrivateRoute roles={['ADMIN','SUPER_ADMIN']}><Layout><Products /></Layout></PrivateRoute>} />

      <Route path="/edit-requests" element={<PrivateRoute roles={['ADMIN','SUPER_ADMIN']}><Layout><EditRequests /></Layout></PrivateRoute>} />

      <Route path="/dashboard" element={<PrivateRoute roles={['SUPER_ADMIN']}><Layout><Dashboard /></Layout></PrivateRoute>} />
      <Route path="/reports" element={<PrivateRoute roles={['SUPER_ADMIN']}><Layout><Reports /></Layout></PrivateRoute>} />
      <Route path="/users" element={<PrivateRoute roles={['SUPER_ADMIN']}><Layout><Users /></Layout></PrivateRoute>} />

      <Route path="*" element={<Navigate to="/invoices" />} />
    </Routes>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  )
}
